import { render, staticRenderFns } from "./ScoreBasfi.vue?vue&type=template&id=38cb2530&scoped=true"
import script from "./ScoreBasfi.vue?vue&type=script&lang=js"
export * from "./ScoreBasfi.vue?vue&type=script&lang=js"
import style0 from "./ScoreBasfi.vue?vue&type=style&index=0&id=38cb2530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cb2530",
  null
  
)

export default component.exports